import { createContext, useEffect, useState } from "react";

import ListItem from "../components/ListItem/ListItem";
import { fetchData } from "../util/api";
import { handleQueryStrings } from "../util/query";

const { ppcid, cid, buttonTitle, listingType } = handleQueryStrings()

const AppContext = createContext({
  isLoading: true,
  hasError: false,
  listings: null,
  ppcid: ppcid,
  cid: cid,
  modalIsOpen: false,
  learnMoreModalIsOpen: false,
  showStatic: false,
  handleOpen: () => { },
  handleClose: () => { },
  handleLearnMoreOpen: () => { },
  handleLearnMoreClose: () => { }
})

export const AppContextProvider = (props) => {
  const [isLoading, setIsLoading] = useState(true)
  const [hasError, setHasError] = useState(false)
  const [listings, setListings] = useState([])
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [learnMoreModalIsOpen, setLearnMoreModalIsOpen] = useState(false)
  const [showStatic, setShowStatic] = useState(false)

  const handleOpenModal = () => {
    setModalIsOpen(true)
  }

  const handleCloseModal = () => {
    setModalIsOpen(false)
  }

  useEffect(() => {
    const updateBankrateData = async () => {
      const response = await fetchData();
      if (response.message === "success") {
        let listingData = response.data.data.savings_mma_rates;

        console.log('listingData', listingData);

        const pid = 'myfi_ratezip_api';

        // if listingType == 'single', filter the listingData, keeping only institution.name == 'Marcus by Goldman Sachs'
        if (listingType === 'single') {
          listingData = listingData.filter(i => i.institution.name === 'Marcus by Goldman Sachs');
        }

        if (listingType === 'single1') {
          listingData = listingData.filter(i => i.institution.name === 'SoFi');
        }

        if (listingType === 'single2') {
          listingData = listingData.filter(i => i.institution.name === 'Capital One');
        }

        if (listingData.length < 4) {
          setShowStatic(true)
        }

        window.dataLayer.push({
          'listing_count': listingData.length,
          'event': 'listings_are_loaded'
        });

        setListings(listingData.map((i, index) => {
          return (
            <ListItem
              key={index + 1}
              id={index + 1}
              name={i.institution.name}
              product={i.product.name}
              isCheckwrite={i.is_checkwrite}
              monthlyService={i.fees.monthly_service.toFixed(2)}
              offerDetails={i.offer_details}
              minToAvoidFee={i.fees.min_to_avoid_fees.toFixed(2)}
              apy={i.apy}
              logo={i.institution.logo_url}
              advertiser_notes={i.advertiser_notes}
              min_to_open={i.min_to_open.toFixed(2)}
              phone={i.phone}
              link={`${i.ep_url}?clkid=${ppcid}_${cid
                }&utm_source=RateZip+API&pid=${pid}&utm_medium=partner`}
              rating={i.institution.reviews.savings_rating || i.institution.reviews.overall_rating}
              effective_at={i.effective_at}
              member={i.institution.insurance_information.type}
              buttonTitle={buttonTitle}
            />
          );
        }))
        setIsLoading(false)
      } else {
        setHasError('No offers found')
        setIsLoading(false)
      }
    }

    updateBankrateData()
  }, []);

  return (
    <AppContext.Provider
      value={{
        isLoading: isLoading,
        hasError: hasError,
        listings: listings,
        modalIsOpen: modalIsOpen,
        learnMoreModalIsOpen: learnMoreModalIsOpen,
        showStatic: showStatic,
        ppcid: ppcid,
        cid: cid,
        handleClose: handleCloseModal,
        handleOpen: handleOpenModal,
        handleLearnMoreOpen: () => setLearnMoreModalIsOpen(true),
        handleLearnMoreClose: () => setLearnMoreModalIsOpen(false)
      }}
    >
      {props.children}
    </AppContext.Provider>
  )
}

export default AppContext